<template>
  <app-layout>
    <div class="mx-auto sm:px-6 lg:px-8 py-6">
      <action-message :on="$page.props.message"></action-message>
      <action-message :on="$page.props.error" error></action-message>
      <user-home></user-home>
    </div>
  </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue';
import UserHome from './UserHome.vue';
import ActionMessage from '../../Jetstream/ActionMessage.vue';

export default {
  components: {
    UserHome,
    AppLayout,
    ActionMessage,
  },
};
</script>
